import React, { useEffect, useState } from 'react';
import Star from '../../assets/icons/star';
import './WhereDidUHearPopup.css';
import { fetcher } from '../../services/api';
import { useUser } from '../../contexts/UserContext';

interface WhereDidUHearPopupProps {
  onClose: (showToast?: boolean) => void; 
}

export default function WhereDidUHearPopup({ onClose }: WhereDidUHearPopupProps) {
  const [options, setOptions] = useState<string[]>([]);
  const [displayOptions, setDisplayOptions] = useState<string[]>([]);
  const [selected, setSelected] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const { refetchUser } = useUser();

  useEffect(() => {
    const getOptions = async () => {
      const res = await fetcher<{ result: boolean; data: string[] }>('/publisher/user/referrer-source');
      if (res.data?.result && Array.isArray(res.data.data)) {
        setOptions(res.data.data);
        setDisplayOptions(res.data.data.map(capitalize));
      } else {
        console.error('Failed to load options:', res.error);
      }
    };

    getOptions();
  }, []);

  const capitalize = (str: string) =>
    str
      .split('/')
      .map(part => part.charAt(0).toUpperCase() + part.slice(1))
      .join('/');

  const handleSelect = async (optionRaw: string) => {
    setSelected(optionRaw);
    setIsSubmitting(true);

    try {
      const response = await fetcher<{ result: boolean }>(
        '/publisher/user/referrer-source',
        {
          method: 'PATCH',
          body: JSON.stringify({ referrer_source: optionRaw }),
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data?.result) {
        await refetchUser();
        const wasSkipped = optionRaw.toLowerCase() === "skip";
        onClose(!wasSkipped);
      } else {
        console.error('Failed to save selection');
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error('Failed to save selection:', error);
      setIsSubmitting(false);
    }
  };

  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <div className="star"><Star /></div>
        <h3>Where did you hear about us?</h3>
        <p>Let us know how you discovered KLIPY</p>
        <div className="popup-options">
          {options
            .filter(opt => opt.toLowerCase() !== '')
            .map((optRaw, idx) => {
              const display = displayOptions[idx];
              return (
                <button
                  key={optRaw}
                  className={`popup-option ${selected === optRaw ? 'selected' : ''}`}
                  onClick={() => handleSelect(optRaw)}
                  disabled={isSubmitting}
                >
                  {display}
                </button>
              );
            })}
        </div>
      </div>
    </div>
  );
}
